import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";

export const useDeleteLayout = (
    data: { reportType: string, layoutName: string },
    onSuccess: (result: ApiResult) => void,
    onError: (error: string) => void
) => {

    const {mutate, isLoading} = useMutation({
        mutationFn: async () => {
            return await apiClient.delete("system-reports/layout", {params: data}) as ApiResult;
        },
        onSuccess: async (result) => {
            if (result.isSuccess)
                onSuccess(result);
            else
                onError('Error when submitting material order: ' + result.errorMessage!);
        },
        onError(error) {
            onError(error as string);
        }
    });

    return {
        mutate, isLoading
    }
}
